<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="englobe-params">
    <div class="params-row top">
      <FiltersMenu
        :active-filters="activeFilters"
        :is-loading="!store.filters"
        @remove-filter="removeFilterItem"
        @reset-all-filters="resetAllFilters"
      >
        <SearchAsYouTypeFilter
          v-if="!store.isFollawedActive"
          filter="author"
          :items="store.authors"
          item-label="name"
          item-value="_id"
          :active-filters="selectedFilters.author"
          :is-loading="store.isAuthorFilterLoading"
          @search="fetchSearchAuthors"
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetAuthorFilter"
        >
          Auteurs
        </SearchAsYouTypeFilter>
        <SelectMultipleCounter
          v-for="(value, key) in filtersNames"
          :key="key"
          :filter="key"
          :items="store.filters[key]"
          :active-filters="selectedFilters[key]"
          has-search
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetFilter"
        >
          {{ value }}
        </SelectMultipleCounter>
      </FiltersMenu>

      <FollawedRadioButtonsNew />
    </div>

    <!-- Stats -->
    <AmendmentStats
      v-if="!store.isFollawedActive && store.amendmentsCount > 0"
    />

    <div class="params-row">
      <TotalMatched :item-count="store.item_count" feminine />
      <div class="page-settings">
        <!-- Export -->
        <div class="export-wrapper">
          <ExportButton
            :disabled="store.loadingExcel"
            icon-name="file-spreadsheet"
            @click="store.downloadExcel()"
          >
            <span v-if="store.loadingExcel">(En cours)</span>
            <span v-else>Exporter en .xlsx</span>
          </ExportButton>
        </div>

        <DropdownMenu
          v-model="selectedSorterOption"
          :options="sortersOptions"
          label="Trier par :"
        />

        <DropdownMenu
          v-model="selectedLimitOption"
          :options="limitOptions"
          label="Amendements par page :"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import FiltersMenu from "@follaw-fr/components/filter-menu/organisms/FiltersMenu.vue";
import SearchAsYouTypeFilter from "@follaw-fr/components/filter-menu/molecules/SearchAsYouTypeFilter.vue";
import SelectMultipleCounter from "@follaw-fr/components/filter-menu/molecules/SelectMultipleCounter.vue";
import ExportButton from "@follaw-fr/components/reusable/atoms/ExportButton.vue";
import TotalMatched from "@follaw-fr/components/reusable/atoms/TotalMatched.vue";
import AmendmentStats from "../molecules/AmendmentStats.vue";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useAmendmentsStore } from "@/follaw-fr/stores/amendments";
import { useDropdown } from "@follaw-fr/composables/useDropdown";
import FollawedRadioButtonsNew from "../../reusable/atoms/FollawedRadioButtons.vue";

const store = useAmendmentsStore();
const { selectedFilters } = storeToRefs(store);

const fetchSearchAuthors = (nameSearch) => {
  if (nameSearch.length > 0) {
    store.getSearchAuthorsFilters(nameSearch);
  } else {
    store.resetSearchAuthorsFilters();
  }
};

const { options: sortersOptions, selectedValue: selectedSorterOption } =
  useDropdown({
    options: {
      created_at: "Date",
      nb_cosignataires: "Nombre de cosignataires",
    },
    selectedFilters,
    filterKey: "sort_field", // Matches a key in initialAmendmentsFilters
  });

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters,
    filterKey: "size", // Matches a key in initialAmendmentsFilters
  });

const showScrollTop = computed(() => selectedFilters.value.size > 20);

// All filters in wanted display order with their labels
const filtersNames = {
  status: "Statut",
  institution: "Lieu de dépôt",
  action: "Type d'action",
  examined_by: "Examinateur",
  group: "Groupe",
  etape_institutionelle: "Etape",
};

const activeFilters = computed(() => {
  let arr = [];
  // Put all selected options from all filters with said filter name in an array for the SelectedFilters component
  Object.keys(filtersNames).forEach((key) => {
    selectedFilters.value[key]?.forEach((filter) => {
      arr = [...arr, { filter: key, item: filter }];
    });
  });
  selectedFilters.value.author?.forEach((filter) => {
    arr = [
      ...arr,
      {
        filter: "author",
        item: filter,
      },
    ];
  });
  return arr;
});

const resetAllFilters = () => {
  store.resetFilters();
};

const addFilterItem = (event) => {
  const targetFilters = selectedFilters.value[event.filter] || [];

  selectedFilters.value = {
    ...selectedFilters.value,
    [event.filter]: [...targetFilters, event.item],
  };
};

const removeFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] || [];

  targetFilters = targetFilters.filter((el) => el !== event.item);

  if (targetFilters.length === 0) {
    delete selectedFilters.value[event.filter];
  } else {
    selectedFilters.value = {
      ...selectedFilters.value,
      [event.filter]: targetFilters,
    };
  }
};

const resetFilter = (event) => {
  delete selectedFilters.value[event];
};

const resetAuthorFilter = () => {
  store.resetSearchAuthorsFilters();
  delete selectedFilters.value.author;
};
</script>
